import Vue from "vue";
import Vuex from "vuex";
import VuexPersistance from "vuex-persist";
import axios from "../config";

Vue.use(Vuex);
const vuexLocal = new VuexPersistance({
  storage: window.localStorage
});
export default new Vuex.Store({
  state: {
    userAccount: {
      userName: "",
      password: "",
      role: "",
      profileName:"",
      domain:"",
    },
    print:false,
    // recordData:{
    //   fromDate:"",
    //   toDate:"",
    //   checkedAll : false,
    //   doctor : {
    //     profileName : "ALL",
    //     userAccountId : 0
    //   },
    //   user : {
    //     profileName : "ALL",
    //     userAccountId : 0
    //   },
    //   type: "ALL"

    // },
    uiAccept:{},
    voucherUser:[],
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    updateUserAccount: function(state, value) {
      state.userAccount = value;
      if (value.password != undefined) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `dental${value.password}`;
      } else {
        axios.defaults.headers.common["Authorization"] = `dental`;
      }
    },
    removeUserAccount: function(state) {
      state.userAccount = {};
    },
    updatePrint: function(state,value) {
      state.print = value;
    },
    saveRecordData: function(state,value) {
      state.recordData = value;
    },
    updateUiAccept: function(state,value) {
      state.uiAccept = value;
    },
    updateVoucherUser: function(state,value) {
      state.voucherUser = value;
    },
  },
  actions: {}
});
